<template>
    <div class="bg-white shadow rounded-2xl overflow-hidden shadow">
        <div class="flex flex-col md:flex-row gap-4 md:gap-6 items-center bg-active-50 p-10">
            <div class="w-full md:w-1/2 space-y-4">
                <h2 class="text-1xl md:text-4xl line font-bold text-gray-800">
                    Kết nối vận chuyển hàng hóa thông minh
                </h2>
                <p class="text-lg md:text-xl text-gray-600">
                    Giải pháp toàn diện giúp nhà xuất nhập khẩu dễ dàng kết nối với đơn vị vận chuyển nội địa, tối ưu chi phí và thời gian giao nhận hàng hóa.
                </p>
                <hts-form-button
                    color="primary"
                    size="large"
                    :outline="false"
                    @click="toViewSearch">
                    Tra cứu chuyến xe ngay
                </hts-form-button>
            </div>

            <div class="w-full md:w-1/2 rounded-xl overflow-hidden shadow-lg relative">
                <div class="pb-[66.67%]" />
                <img
                    class="absolute inset-0 object-cover w-full h-full object-center transform hover:scale-105 transition-transform duration-500"
                    :src="xetaiImg"
                    alt="Xe tải" >
            </div>
        </div>
        <SearchBooking
            ref="searchBooking"
            class="p-10" />

        <section class="bg-gray-50 p-10">
            <div class="max-w-6xl mx-auto px-4 text-center">
                <h2 class="text-2xl font-bold mb-6">
                    Tại sao chọn nền tảng của chúng tôi?
                </h2>
                <p class="mb-10 text-lg">
                    Tối ưu hóa quy trình vận chuyển với công nghệ hiện đại
                </p>
                <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
                    <div class="bg-white p-6 rounded-xl shadow flex justify-center flex-col items-center gap-2">
                        <hi-magnifying-glass-icon class="w-12 h-12 p-2 text-blue-500 bg-blue-200 rounded-full" />
                        <p class="font-semibold text-lg">
                            Tìm xe thông minh
                        </p>
                        <p>
                            Tìm xe theo loại hàng, địa điểm và thời gian phù hợp
                        </p>
                    </div>
                    <div class="bg-white p-6 rounded-xl shadow flex justify-center flex-col items-center gap-2">
                        <hi-currency-dollar-icon class="w-12 h-12 p-2 text-green-500 bg-green-200 rounded-full" />
                        <p class="font-semibold text-lg">
                            Giá thời gian thực
                        </p>
                        <p>
                            Xem và so sánh giá cước minh bạch theo thời gian thực
                        </p>
                    </div>
                    <div class="bg-white p-6 rounded-xl shadow flex justify-center flex-col items-center gap-2">
                        <hi-map-icon class="w-12 h-12 p-2 text-purple-500 bg-purple-200 rounded-full" />
                        <p class="font-semibold text-lg">
                            Theo dõi hành trình
                        </p>
                        <p>
                            Giám sát và cập nhật trạng thái giao hàng 24/7
                        </p>
                    </div>
                    <div class="bg-white p-6 rounded-xl shadow flex justify-center flex-col items-center gap-2">
                        <hi-document-text-icon class="w-12 h-12 p-2 text-orange-500 bg-orange-200 rounded-full" />
                        <p class="font-semibold text-lg">
                            Quản lý chứng từ
                        </p>
                        <p>
                            Lưu trữ và quản lý tất cả chứng từ vận chuyển
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section class="py-12">
            <div class="max-w-6xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-12">
                <div class="flex-1">
                    <h2 class="text-2xl font-bold text-gray-900 mb-6">
                        Dành cho nhà xuất nhập khẩu
                    </h2>

                    <ul class="space-y-4 text-left">
                        <li class="flex items-start space-x-2">
                            <hi-check-icon class="text-green-500 w-7 h-7" />
                            <div>
                                <p class="font-semibold text-gray-800">
                                    Tiết kiệm thời gian
                                </p>
                                <p class="text-gray-600 text-sm">
                                    Tìm và đặt xe chỉ trong vài phút
                                </p>
                            </div>
                        </li>
                        <li class="flex items-start space-x-2">
                            <hi-check-icon class="text-green-500 w-7 h-7" />
                            <div>
                                <p class="font-semibold text-gray-800">
                                    Tối ưu chi phí
                                </p>
                                <p class="text-gray-600 text-sm">
                                    So sánh giá từ nhiều nhà cung cấp
                                </p>
                            </div>
                        </li>
                        <li class="flex items-start space-x-2">
                            <hi-check-icon class="text-green-500 w-7 h-7" />
                            <div>
                                <p class="font-semibold text-gray-800">
                                    Minh bạch giá cước
                                </p>
                                <p class="text-gray-600 text-sm">
                                    Không phí ẩn, không qua trung gian
                                </p>
                            </div>
                        </li>
                    </ul>

                    <button class="mt-8 bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-blue-700 transition">
                        Khám phá dashboard khách hàng
                    </button>
                </div>
                <div class="flex-1">
                    <div class="w-full rounded-xl overflow-hidden shadow-lg relative">
                        <div class="pb-[66.67%]" />
                        <img
                            class="absolute inset-0 object-cover w-full h-full object-center transform hover:scale-105 transition-transform duration-500"
                            :src="xetaiImg"
                            alt="Xe tải" >
                    </div>
                </div>
            </div>
        </section>

        <section class="py-12 bg-gray-50">
            <div class="max-w-6xl mx-auto px-4 flex flex-col lg:flex-row-reverse items-center gap-12">
                <div class="flex-1">
                    <h2 class="text-2xl font-bold text-gray-900 mb-6">
                        Dành cho nhà cung cấp vận tải
                    </h2>

                    <ul class="space-y-4 text-left">
                        <li class="flex items-start space-x-2">
                            <hi-truck-icon class="text-blue-500 w-7 h-7" />
                            <div>
                                <p class="font-semibold text-gray-800">
                                    Quản lý đội xe
                                </p>
                                <p class="text-gray-600 text-sm">
                                    Theo dõi và điều phối toàn bộ đội xe
                                </p>
                            </div>
                        </li>
                        <li class="flex items-start space-x-2">
                            <hi-clock-icon class="text-blue-500 w-7 h-7" />
                            <div>
                                <p class="font-semibold text-gray-800">
                                    Tối ưu thời gian vận chuyển
                                </p>
                                <p class="text-gray-600 text-sm">
                                    Giảm thời gian, chi phí và tăng hiệu quả vận chuyến
                                </p>
                            </div>
                        </li>
                        <li class="flex items-start space-x-2">
                            <hi-arrow-trending-up-icon class="text-blue-500 w-7 h-7" />
                            <div>
                                <p class="font-semibold text-gray-800">
                                    Tăng doanh thu
                                </p>
                                <p class="text-gray-600 text-sm">
                                    Tiếp cận nhiều khách hàng tiềm năng
                                </p>
                            </div>
                        </li>
                        <li class="flex items-start space-x-2">
                            <hi-device-phone-mobile-icon class="text-blue-500 w-7 h-7" />
                            <div>
                                <p class="font-semibold text-gray-800">
                                    Ứng dụng tài xế
                                </p>
                                <p class="text-gray-600 text-sm">
                                    Công cụ hỗ trợ tài xế chuyên nghiệp
                                </p>
                            </div>
                        </li>
                    </ul>

                    <button class="mt-8 bg-orange-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-orange-700 transition">
                        Tham gia ngay
                    </button>
                </div>
                <div class="flex-1">
                    <div class="w-full rounded-xl overflow-hidden shadow-lg relative">
                        <div class="pb-[66.67%]" />
                        <img
                            class="absolute inset-0 object-cover w-full h-full object-center transform hover:scale-105 transition-transform duration-500"
                            :src="xetaiImg"
                            alt="Xe tải" >
                    </div>
                </div>
            </div>
        </section>

        <section class="py-12 bg-blue-700 text-white text-center">
            <div class="max-w-xl mx-auto px-4">
                <h3 class="text-xl font-semibold mb-4">
                    Sẵn sàng tối ưu hóa vận chuyển của bạn?
                </h3>
                <p class="mb-6">
                    Tham gia cùng hàng nghìn doanh nghiệp đã tin tưởng sử dụng nền tảng của chúng tôi
                </p>
                <div class="flex justify-center gap-4">
                    <button class="px-4 py-2 border border-white rounded">
                        Yêu cầu demo
                    </button>
                </div>
            </div>
        </section>

        <footer class="bg-gray-900 text-white py-10">
            <div class="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-4 gap-6">
                <div>
                    <h4 class="font-semibold mb-2">
                        TruckTek
                    </h4>
                    <p class="text-sm">
                        Giải pháp vận chuyển thông minh cho doanh nghiệp
                    </p>
                </div>
                <div>
                    <h4 class="font-semibold mb-2">
                        Liên kết nhanh
                    </h4>
                    <ul class="space-y-1 text-sm">
                        <li>
                            Giới thiệu
                        </li>
                        <li>
                            Chính sách bảo mật
                        </li>
                        <li>
                            Điều khoản sử dụng
                        </li>
                    </ul>
                </div>
                <div>
                    <h4 class="font-semibold mb-2">
                        Liên hệ
                    </h4>
                    <ul class="space-y-1 text-sm">
                        <li>
                            Email: info@trucktek.vn
                        </li>
                        <li>
                            Hotline: trucktek
                        </li>
                        <li>
                            Địa chỉ: TP. Hồ Chí Minh
                        </li>
                    </ul>
                </div>
                <div>
                    <h4 class="font-semibold mb-2">
                        Mạng xã hội
                    </h4>
                    <div class="flex space-x-4">
                        <span>
                            📘
                        </span>
                        <span>
                            📸
                        </span>
                        <span>
                            🔗
                        </span>
                    </div>
                </div>
            </div>
            <p class="text-center text-sm mt-6">
                © 2024 TruckTek. Tất cả quyền được bảo lưu.
            </p>
        </footer>
    </div>
</template>
<script setup lang="ts">
import SearchBooking from '../../components/search-booking/index.vue'
import xetaiImg from '@/public/assets/xetai.png'
definePageMeta({
  layout: 'user'
})

const searchBooking = ref()

const toViewSearch = () => {
  if (searchBooking.value && searchBooking.value.$el) {
    searchBooking.value.$el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }
}
</script>
